__turbopack_context__.v({
  "leftSidebar": "LThreeCols-module__DMa-KW__leftSidebar",
  "main": "LThreeCols-module__DMa-KW__main",
  "rightSidebar": "LThreeCols-module__DMa-KW__rightSidebar",
  "root": "LThreeCols-module__DMa-KW__root",
});
